import { TFunction } from 'react-i18next';
import { CS_LANGUAGE, SK_LANGUAGE } from '../constants';

export const getLanguageOptions = (t: TFunction) =>
  [CS_LANGUAGE, SK_LANGUAGE].map((value) => ({
    value,
    title: t(value),
  }));
